import { MDBBtn, MDBIcon, MDBModalFooter, MDBTextArea } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import PopupLoaderNew from "../popups/PopupLoaderNew";
import PopupLoader from "../popups/PopupLoader";

function SMSCampaignDetails({
  register,
  watch,
  setValue,
  errors,
  optinMessage,
  optOutMessage,
  helpMessage,
}) {
  const numToWord = [
    { 1: "one" },
    { 2: "two" },
    { 3: "three" },
    { 4: "four" },
    { 5: "five" },
  ];
  const [showAlert, setshowAlert] = useState(false);
  const showAlertToggle = () => {
    setshowAlert(!showAlert);
  };
  const [messages, setMessages] = useState([]);
  // const [messages, setMessages] = useState(
  //   parseInt(watch("usecases.case")) === 7 ||
  //     parseInt(watch("usecases.case")) === 10
  //     ? [
  //         {
  //           id: 1,
  //           text: watch("campaign_details.camp_desc.smpl_msgs.one"),
  //         },
  //         {
  //           id: 2,
  //           text: watch("campaign_details.camp_desc.smpl_msgs.two"),
  //         },
  //       ]
  //     : [
  //         {
  //           id: 1,
  //           text: watch("campaign_details.camp_desc.smpl_msgs.one"),
  //         },
  //       ]
  // );
  useEffect(() => {
    // if (
    //   parseInt(watch("usecases.case")) === 7 ||
    //   parseInt(watch("usecases.case")) === 10
    // ) {
    //   setMessages([
    //     {
    //       id: 1,
    //       text: watch("campaign_details.camp_desc.smpl_msgs.one"),
    //     },
    //     {
    //       id: 2,
    //       text: watch("campaign_details.camp_desc.smpl_msgs.two"),
    //     },
    //   ]);
    // } else {
    //   setMessages([
    //     {
    //       id: 1,
    //       text: watch("campaign_details.camp_desc.smpl_msgs.one"),
    //     },
    //   ]);
    // }
    let updateMsg = [];

    numToWord.forEach((num, index) => {
      const fieldName = `campaign_details.camp_desc.smpl_msgs.${numToWord[index][index + 1]}`;
      const message = watch(fieldName);

      if (message !== "") {
        updateMsg = [
          ...updateMsg,
          { id: index + 1, text: message, name: fieldName },
        ];
      }
    });

    setMessages(updateMsg);
  }, [watch("usecases.case")]);

  const deleteMessage = (id) => {
    const updatedMessages = messages.filter((message) => message.id !== id);
    const rearrangedMessages = updatedMessages.map((message, index) => ({
      ...message,
      id: index + 1,
    }));
    setMessages(rearrangedMessages);

    rearrangedMessages.forEach((message, index) => {
      const messageKey = numToWord[index][index + 1];
      setValue(
        `campaign_details.camp_desc.smpl_msgs.${messageKey}`,
        message.text,
        {
          shouldDirty: true,
        }
      );
    });
  };

  const addMessage = () => {
    const newMessage = {
      id: messages.length + 1,
      text: "",
    };
    setMessages([...messages, newMessage]);
  };

  return (
    <>
      <div className="general-settings">Campaign Details</div>

      <h5 className="my-3">Campaign and Content Attributes</h5>
      <div class="add-numbermain">
        <div class="tel-numbers">Subscriber Opt-in</div>
        <div className="w-30">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckboxid"
              checked={true}
              //   {...register("conf_flag")}
              //   onChange={() => {
              //     setIsConferenceBridge((obj) => !obj);
              //     handleToggleChange();
              //   }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Subscriber Opt-out</div>
        <div className="w-30">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckboxid"
              checked={true}
              //   {...register("conf_flag")}
              //   onChange={() => {
              //     setIsConferenceBridge((obj) => !obj);
              //     handleToggleChange();
              //   }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Subscriber help</div>
        <div className="w-30">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckboxid"
              checked={true}
              //   {...register("conf_flag")}
              //   onChange={() => {
              //     setIsConferenceBridge((obj) => !obj);
              //     handleToggleChange();
              //   }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Number pooling</div>
        <div className="w-30">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckboxid"
              {...register("campaign_details.camp_attribs.num_pool")}
              //   {...register("conf_flag")}
              //   onChange={() => {
              //     setIsConferenceBridge((obj) => !obj);
              //     handleToggleChange();
              //   }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Direct lending or loan arrangement</div>
        <div className="w-30">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckboxid"
              {...register("campaign_details.camp_attribs.direct_lend")}
              //   {...register("conf_flag")}
              //   onChange={() => {
              //     setIsConferenceBridge((obj) => !obj);
              //     handleToggleChange();
              //   }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Embedded link</div>
        <div className="w-30">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckboxid"
              {...register("campaign_details.camp_attribs.embed_link")}
              //   {...register("conf_flag")}
              //   onChange={() => {
              //     setIsConferenceBridge((obj) => !obj);
              //     handleToggleChange();
              //   }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Embedded phone number</div>
        <div className="w-30">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckboxid"
              {...register("campaign_details.camp_attribs.embed_phn")}
              //   {...register("conf_flag")}
              //   onChange={() => {
              //     setIsConferenceBridge((obj) => !obj);
              //     handleToggleChange();
              //   }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Affiliate Marketing</div>
        <div className="w-30">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckboxid"
              checked={true}
              //   {...register("conf_flag")}
              //   onChange={() => {
              //     setIsConferenceBridge((obj) => !obj);
              //     handleToggleChange();
              //   }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Age-gated content</div>
        <div className="w-30">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckboxid"
              {...register("campaign_details.camp_attribs.age_gated")}
              //   {...register("conf_flag")}
              //   onChange={() => {
              //     setIsConferenceBridge((obj) => !obj);
              //     handleToggleChange();
              //   }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div>
        <div class="mt-3 fw-500">Subscriber Opt-in Message</div>
        <p className="mt-2">{optinMessage}</p>
      </div>

      <div>
        <div class="mt-3 fw-500">Subscriber Opt-out Message</div>
        <p>{optOutMessage}</p>
      </div>

      <div class="">
        <div class="mt-3 fw-500">Subscriber Help</div>
        <div className="">
          <p>{helpMessage}</p>
        </div>
      </div>

      <h5 className="my-3">Campaign Description</h5>

      <div class="add-numbermain">
        <div class="tel-numbers">Description</div>
        <div className="w-50 text-left">
          <MDBTextArea
            value={watch("campaign_details.camp_desc.desc")}
            onChange={(e) =>
              setValue("campaign_details.camp_desc.desc", e.target.value, {
                shouldDirty: true,
              })
            }
          />
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Call-to-Action / Message Flow</div>
        <div className="w-50 text-left">
          <div className="form-outline">
            <div className="form-control active">
              <textarea
                className="border-0 w-100 "
                style={{ outline: "0" }}
                value={watch("campaign_details.camp_desc.msg_flow")}
                onChange={(e) =>
                  setValue(
                    "campaign_details.camp_desc.msg_flow",
                    e.target.value,
                    {
                      shouldDirty: true,
                    }
                  )
                }
              />
              {watch("campaign_details.camp_desc.msg_flow_chk") && (
                <p className="form-control border-0 cursor-notAllowed">
                  Message & data rates may apply. Reply STOP to opt-out of
                  further messaging. Reply HELP for more information.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Does your website collect Phone numbers?</div>
        <div className="phoneselect">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              checked={watch("campaign_details.camp_desc.msg_flow_chk")}
              onChange={(e) => {
                setValue(
                  "campaign_details.camp_desc.msg_flow_chk",
                  e.target.checked,
                  { shouldDirty: true }
                );
                if (e.target.checked) {
                  showAlertToggle();
                }
              }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between">
        <div>
          <h5 className="my-3">Sample Messages</h5>
          <strong>Note:</strong>The following text will be appended with the
          Sample Message : Reply STOP to Opt-out of receiving messages from Beta
          Network Brand.
        </div>

        <div className="text-end mt-3">
          <MDBBtn onClick={addMessage} disabled={messages.length >= 5}>
            <MDBIcon fas icon="plus" className="me-2" /> Add New Sample Message
          </MDBBtn>
        </div>
      </div>
      {messages.map((message) => (
        <div className="add-numbermain" key={message.id}>
          <div className="tel-numbers">Sample Message - {message.id}</div>
          <div className="w-50 text-left d-flex align-items-center">
            <MDBTextArea
              value={message.text}
              onChange={(e) =>
                setValue(message.name, e.target.value, { shouldDirty: true })
              }
            />
            {(((parseInt(watch("usecases.case")) === 7 ||
              parseInt(watch("usecases.case")) === 10) &&
              messages.length > 2) ||
              (parseInt(watch("usecases.case")) !== 7 &&
                parseInt(watch("usecases.case")) !== 10 &&
                messages.length > 1)) && (
              <MDBIcon
                fas
                icon="times-circle"
                color="danger"
                className="mx-2 fs-4 cursor-pointer"
                onClick={() => deleteMessage(message.id)}
              />
            )}
          </div>
        </div>
      ))}

      {showAlert && (
        <PopupLoader
          title={"Alert"}
          content={
            <>
              <p>
                Please ensure that the following online statement is in clear
                view on your website.
              </p>
              <strong>SMS Disclaimer:</strong>
              <p>
                By providing a telephone number and submitting the form you are
                consenting to be contacted by SMS text message (our message
                frequency may vary). Message & data rates may apply. Reply STOP
                to opt-out of further messaging. Reply HELP for more
                information. See our Privacy Policy.
              </p>
              <MDBModalFooter>
                <MDBBtn onClick={showAlertToggle}>OK</MDBBtn>
              </MDBModalFooter>
            </>
          }
          onShow={setshowAlert}
          onClose={showAlertToggle}
        />
      )}
    </>
  );
}

export default SMSCampaignDetails;
